import { MyPage } from "@macashipo/mlib"

export default MyPage
